module.exports = __webpack_public_path__ + "static/media/in_a_week_cover.f09f366d.jpg";